// Freeman Orthodontics (San Jose CA) - single office.
// Backend: bondLocations.ts FREEMAN_SAN_JOSE (brandId "freeman", catalog f189e3c5,
// Edge loc 2, procedure 433, DB 316). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 316). English-only.
import type { BrandConfig } from "./types";

export const freeman: BrandConfig = {
  slug: "freeman",
  brandId: "freeman",
  brandName: "Freeman Orthodontics",
  logo: "https://mattfreemanortho.com/wp-content/uploads/2017/03/FreemanOrthodontics_Logo_FullColor_Large.png",
  phone: "(408) 513-6166",
  phoneHref: "tel:+14085136166",
  theme: { primary: "#F39E4E", primaryDark: "#28325B" }, // scoured 2026-07-14 mattfreemanortho.com (orange + navy)
  locales: ["en"],
  locations: {
    FREEMAN_SAN_JOSE: {
      id: "FREEMAN_SAN_JOSE",
      name: "San Jose",
      addressLines: ["4205 San Felipe Rd", "San Jose, CA 95135"],
      mapsUrl: "https://maps.google.com/?q=4205+San+Felipe+Rd+San+Jose+CA+95135",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { SAN_JOSE: "FREEMAN_SAN_JOSE", FREEMAN: "FREEMAN_SAN_JOSE" },
};
